module.exports = __webpack_public_path__ + "img/gh36060-3.prt.4cfe1e0c.jpg";